import { axiosReq } from "@/lib/axios"
import { captureApiError } from "@/lib/sentry-fn"
import { queryClient } from "@/lib/react-query" 
import { useMutation } from "@tanstack/react-query"
import { toast } from "sonner"

export const useDiscardEvent = () => {
  const request = async (id: number) => {
    const response = await axiosReq.post('/api/calendar/discard-recommendation/', {
      event_id: id,
    })

    return response.data
  }
  const { mutate: discardEvent, status } = useMutation({
    mutationFn: (id: number) => request(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["themes"] })
      toast.message("Event removed from suggestions")
    }
  })

  return { discardEvent, status }
}

type AddFeedbackArgs = {
  post_id: number,
  rating: number | null,
  user_name: string,
  comment: string | null
}
export const useAddFeedback = () => {

  const request = async (data: AddFeedbackArgs) => {
    const response = await axiosReq.post('/api/landing/feedback/', data)
    return response.data
  }

  const { mutate: addFeedback } = useMutation({
    mutationFn: request
  })

  return { addFeedback }
}

export const useGetCreatedThemeImage = (onImageGenerate: (id: number, name: string) => void) => {

  const request = async (id: number): Promise<{
    status: string,
    data: {
      event_id: number,
      event_name: string
    }
  }> => {
    try {
      const response = await axiosReq.post('/api/approval/generate-images-event/', { event_id: id })
      return response.data
    } catch (error) {

      captureApiError(error, {
        component: "useGetCreatedEventImage",
        url: `${import.meta.env.VITE_API_URL}/api/approval/generate-images-event/`,
        httpMethod: "POST",
        apiEndpoint: "/api/approval/generate-images-event/"
      })

      throw error
    }
  }

  const { data: generatedDataWithImages, status, mutate: generateImage } = useMutation({
    mutationFn: (id: number) => request(id),
    onSuccess: (data) => {
      if (data) {
        onImageGenerate(data.data.event_id, data.data.event_name)
      }
    }
  })
  return { generateImage, generatedDataWithImages, status }
}


